import { createRouter, createWebHashHistory } from "vue-router";
import App from "./App.vue";
import jwtDecode from "jwt-decode";

const routes = [
  {
    path: "/system",
    name: "app",
    component: App,
    children: [
      {
        path: "",
        name: "projects",
        component: () => import("./pages/projects/ProjectsView.vue"),
        beforeEnter: (to, from, next) => {
          if (isPermission('R-STG15')) {
            next();
          } else {
            next({ name: "login" });
          }
        }
      },
      {
        path: "/files",
        name: "files",
        component: () => import("./pages/files/FileView.vue"),
        beforeEnter: (to, from, next) => {
          if (isPermission('R-STG19') || isPermission('R-STG23')) {
            next();
          } else {
            next({ name: "access-denied" });
          }
        }
      },
      {
        path: "/users",
        name: "users",
        component: () => import("./pages/users/UsersView.vue"),
        beforeEnter: (to, from, next) => {
          if (isPermission('R-STG1')) {
            next();
          } else {
            next({ name: "access-denied" });
          }
        }
      },
      {
        path: "/groups",
        name: "groups",
        component: () => import("./pages/groups/GroupsView.vue"),
        beforeEnter: (to, from, next) => {
          if (isPermission('R-STG9')) {
            next();
          } else {
            next({ name: "access-denied" });
          }
        }
      },
      {
        path: "/log",
        name: "log",
        component: () => import("./pages/log/LogView.vue"),
        beforeEnter: (to, from, next) => {
          if (isPermission('R-STG27')) {
            next();
          } else {
            next({ name: "access-denied" });
          }
        }
      },
    ],
  },
  {
    path: "/",
    name: "login",
    component: () => import("./pages/main/Login.vue"),
  },
  {
    path: "/recoverPassword",
    name: "recoverPassword",
    component: () => import("./pages/users/UserRecoverPasswordView.vue"),
  },
  {
    path: "/:catchAll(.*)",
    name: "not-found",
    component: () => import("./pages/not_found/NotFound.vue"),
  },
  {
    path: "/accessDenied",
    name: "access-denied",
    component: () => import("./pages/not_found/AccessDenied.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

const isPermission = (role) => {
  let authorities = jwtDecode(JSON.parse(sessionStorage.getItem("token")).access_token).authorities;
  return authorities.find((e) => e === role) ? true : false
}

export default router;

